var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_10_1961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0713 13.8214C25.0713 17.023 23.7995 20.0934 21.5357 22.3572C19.2719 24.621 16.2014 25.8928 12.9999 25.8928C9.79835 25.8928 6.72794 24.621 4.46411 22.3572C2.20027 20.0934 0.928467 17.023 0.928467 13.8214M25.0713 13.8214C25.0713 10.6199 23.7995 7.54946 21.5357 5.28562C19.2719 3.02179 16.2014 1.74998 12.9999 1.74998C9.79835 1.74998 6.72794 3.02179 4.46411 5.28562C2.20027 7.54946 0.928467 10.6199 0.928467 13.8214M25.0713 13.8214H0.928467",
    stroke: "#03014C",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6426 13.8214C17.4146 18.2358 15.7886 22.4633 12.9998 25.8928C10.211 22.4633 8.58499 18.2358 8.35693 13.8214C8.58499 9.407 10.211 5.17948 12.9998 1.74998C15.7886 5.17948 17.4146 9.407 17.6426 13.8214Z",
    stroke: "#03014C",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.821411)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlLogo);
export default __webpack_public_path__ + "static/media/UrlLogo.9ca7b6a41f45200854c536407ca59f34.svg";
export { ForwardRef as ReactComponent };